<div class="row">
  <div class="col-12 col-lg-6 pb-3">
    <h1 class="custom-header">Latest News</h1>
  </div>
  <div class="col-12 col-lg-6 d-flex justify-content-end pb-3">
    <div>
      <select
        class="select-container dropdown"
        name="Filters"
        [(ngModel)]="selectedTagName"
        (ngModelChange)="filterNewsByCategory()">
        <option value="">
          Select All Categories
        </option>
        @for (tagName of uniqueTagNames; track tagName) {
          <option
            [value]="tagName">
            {{ tagName }}
          </option>
        }
      </select>
    </div>
  </div>
</div>
<div class="row row-cols-1 row-cols-md-2 g-4 mt-1">
  @for (latestNewsItem of filteredNews; track latestNewsItem) {
    <div
      class="col-12 col-md-6 col-sm-12 col-lg-4"
      >
      <div class="card mb-4 custom-card">
        @if (latestNewsItem.imageUrl) {
          <span>
            @if (latestNewsItem.hrefLink) {
              <a
                class="btn"
                href="{{ latestNewsItem.hrefLink }}"
                title="{{ latestNewsItem.hrefText }}">
                <div class="image-container">
                  <img
                    [src]="latestNewsItem.imageUrl"
                    class="card-img-top img-fluid"
                    alt="Latest News Image Link"/>
                  </div>
                </a>
              }
              @if (!latestNewsItem.hrefLink) {
                <a class="btn">
                  <div class="image-container">
                    <img
                      [src]="latestNewsItem.imageUrl"
                      class="card-img-top img-fluid"
                      alt="Latest News Image"/>
                    </div>
                  </a>
                }
              </span>
            }
            <div class="card-body">
              <div class="publish-date">
                <p>
                  {{ latestNewsItem.publishDate | date : 'MMMM dd, yyyy' }}
                </p>
              </div>
              <h2 class="card-title">{{ latestNewsItem.title }}</h2>
              @for (tag of latestNewsItem.tagSelections; track tag) {
                <div class="chip mt-1 pb-1" [ngClass]="tag.color">
                  {{ tag.tagName }}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
